import { SheetMusicState } from '../../../types'

export * from '@thesisedu/feature-sheet-music-core'

export const INSTRUCTIONS = 'Drag and drop the notes or groups of notes onto the staff below.'
export type SheetMusicDragDropAnswer =
  | string
  | (SheetMusicState & { abc: string; mediaId?: string })
